import { mainApi } from '../../../../api/mainApi';
import { middlewareApi } from '../../../middleware/middlewareApi';
import { IResponse } from '../../../shared/interfaces/response.interface';
import {
  ContificoInvoiceDocument,
  ContificoMonthDocument,
} from '../interfaces/migrations.interfaces';

// necesary if require tags
export const migrationContificoTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['migrationContifico'],
});

// Define a service using a base URL and expected endpoints
export const migrationContificoAPI = migrationContificoTags.injectEndpoints({
  endpoints: (builder) => ({
    getContificoDocumentsMonth: builder.query<
      IResponse<ContificoMonthDocument>,
      {
        year: number;
        profileId: number;
        page: number;
        perPage: number;
        sort?: string;
        type_sort?: string;
      }
    >({
      queryFn: async ({ profileId, year, page, perPage, sort, type_sort }) => {
        try {
          const { data } = await mainApi.get<IResponse<ContificoMonthDocument>>(
            `/list-documents-month`,
            {
              params: {
                user_profile_id: profileId,
                year,
                page,
                size: perPage,
                sort,
                type_sort,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [{ type: 'migrationContifico', id: 'List' }],
    }),

    getContificoMonthDetails: builder.query<
      IResponse<ContificoInvoiceDocument>,
      {
        user_profile_id: number;
        page: number;
        size: number;
        sort?: string;
        type_sort?: string;
        month: number;
        por_migrar: string;
        year: number;
      }
    >({
      queryFn: async ({
        user_profile_id,
        page,
        size,
        sort,
        type_sort,
        month,
        por_migrar,
        year,
      }) => {
        try {
          const { data } = await mainApi.get<IResponse<ContificoInvoiceDocument>>(
            `/list-documents-customer`,
            {
              params: {
                user_profile_id,
                page,
                size,
                sort,
                type_sort,
                month,
                por_migrar,
                year,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [{ type: 'migrationContifico', id: 'List' }],
    }),

    migrateInvoices: builder.mutation<
      any,
      {
        user_profile_id: number;
        documentsSriCabId: number[];
      }
    >({
      queryFn: async ({ user_profile_id, documentsSriCabId }) => {
        try {
          const { data } = await mainApi.post<any>(`/sri-documents-migrate-contifico`, {
            user_profile_id,
            sri_cabecera_id: documentsSriCabId,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'migrationContifico', id: 'List' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetContificoDocumentsMonthQuery,
  useGetContificoMonthDetailsQuery,
  useMigrateInvoicesMutation,
} = migrationContificoAPI;
